import { styled } from 'styled-components';

import {
  BORDER_WIDTH,
  getSegmentedChipsContainerBorderRadius,
} from '@/components/chips/chips.constants.ts';
import type { ChipsSize, SegmentedChipsRadiusRules } from '@/components/chips/chips.types.ts';
import { colors, responsive } from '@/utils';

const containerStyles: Record<ChipsSize, { padding: string; gap: string }> = {
  xSmall: {
    padding: responsive.spacing.xsmall,
    gap: '0',
  },
  small: {
    padding: responsive.spacing.xsmall,
    gap: responsive.spacing.xsmall,
  },
  medium: {
    padding: responsive.spacing.small,
    gap: responsive.spacing.small,
  },
};

export const PillContainer = styled.div<{
  $size: ChipsSize;
  $radiusRules: SegmentedChipsRadiusRules;
}>`
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: ${({ $size }) => containerStyles[$size].padding};
  gap: ${({ $size }) => containerStyles[$size].gap};
  border: ${BORDER_WIDTH} solid ${colors.stroke.neutral[100]};
  border-radius: ${({ $size, $radiusRules }) =>
    getSegmentedChipsContainerBorderRadius($size, $radiusRules)};
  background-color: ${colors.background[100]};
  > * {
    flex: 0 0 auto;
  }
`;
